package features.auth.data

import kotlin.js.Promise
import core.firebase.FirestoreClient
import features.auth.domain.User

/**
 * Repository for user-related database operations
 */
object UserRepository {
    private val db get() = FirestoreClient.db
    
    /**
     * Create or update a user in Firestore
     */
    fun createOrUpdateUser(user: User): Promise<Unit> {
        console.log("========================================")
        console.log("💾 UserRepository.createOrUpdateUser called")
        console.log("========================================")
        console.log("👤 User ID:", user.id)
        console.log("👤 User Name:", user.name)
        console.log("👤 User Email:", user.email)
        console.log("👤 User Avatar:", user.avatar)
        
        // Create userData object dynamically
        val userData: dynamic = js("{}")
        userData.email = user.email
        userData.name = user.name
        userData.avatar = user.avatar
        userData.createdAt = js("new Date()")
        
        console.log("📦 userData prepared:")
        console.log("  email:", userData.email)
        console.log("  name:", userData.name)
        console.log("  avatar:", userData.avatar)
        console.log("🔥 Calling Firestore set() on path: users/${user.id}")
        
        val docRef = db.collection("users").doc(user.id)
        
        return docRef.set(userData, js("{ merge: true }"))
            .then {
                console.log("✅ Firestore set() returned success")
                console.log("🔍 Verifying user was saved...")
                
                // Verify by reading back
                docRef.get()
            }
            .then { snapshot ->
                console.log("🔍 Snapshot object:", snapshot)
                // In Firebase Compat/v8, exists is a property
                val exists = snapshot.asDynamic().exists
                console.log("🔍 Exists property value:", exists)
                
                if (exists == true) {
                    val data = snapshot.data()
                    console.log("✅ VERIFIED: User saved to Firestore!")
                    console.log("  Saved email:", data.asDynamic().email)
                    console.log("  Saved name:", data.asDynamic().name)
                } else {
                    console.error("❌ VERIFICATION FAILED: Document does not exist after save!")
                }
            }
            .catch { error ->
                console.error("❌ Firestore operation failed:", error)
                console.error("Error message:", error.asDynamic().message)
                console.error("Error code:", error.asDynamic().code)
                console.error("Error stack:", error.asDynamic().stack)
                throw error
            }
    }
}
